import { Link } from 'react-router-dom';
import CommissionStatusBadge from './CommissionStatusBadge';
import { formatJalaliDateTime } from '@/lib/format';

const fmt = (n) =>
    new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(
        Number(n) || 0
    );

const fmtDate = formatJalaliDateTime;

export default function CommissionTable({
                                            commissions,
                                            onApprove,
                                            onCancel,
                                            onRestore,
                                            loading,
                                            showUserLinks = false,
                                        }) {
    if (!commissions || commissions.length === 0) {
        return <div className="empty-state">پورسانتی یافت نشد.</div>;
    }

    return (
        <div className="table-wrap">
            <table className="commissions-table">
                <thead>
                <tr>
                    <th>سطح</th>
                    <th>درصد</th>
                    <th>مبلغ (ریال)</th>
                    <th>وضعیت</th>
                    <th>تاریخ</th>
                    {showUserLinks && <th>ذی‌نفع / خریدار</th>}
                    <th>عملیات</th>
                </tr>
                </thead>
                <tbody>
                {commissions.map((c) => {
                    const isPending = c.status === 'pending';
                    const isCancelled = c.status === 'cancelled';
                    const isPaid = c.status === 'paid';

                    return (
                        <tr key={c.id}>
                            <td>{c.level}</td>
                            <td>{Number(c.percent).toFixed(2)}٪</td>
                            <td>{fmt(c.amount)}</td>
                            <td>
                                <CommissionStatusBadge status={c.status} />
                            </td>
                            <td>{fmtDate(c.created_at)}</td>
                            {showUserLinks && (
                                <td>
                                    <div className="user-links">
                                        <Link
                                            to={`/super-admin/commissions?beneficiary_id=${c.beneficiary_id}`}
                                            className="user-link"
                                            title="نمایش پورسانت‌های این کاربر"
                                        >
                                            <span className="user-link-role">ذی‌نفع:</span>
                                            <span className="user-link-name">
                          {c.beneficiary_name || '—'}
                        </span>
                                            {c.beneficiary_referral_code && (
                                                <span className="user-link-code">
                            {c.beneficiary_referral_code}
                          </span>
                                            )}
                                        </Link>
                                        <Link
                                            to={`/super-admin/commissions?beneficiary_id=${c.source_user_id}`}
                                            className="user-link user-link-secondary"
                                            title="نمایش پورسانت‌های این خریدار"
                                        >
                                            <span className="user-link-role">خریدار:</span>
                                            <span className="user-link-name">
                          {c.source_user_name || '—'}
                        </span>
                                        </Link>
                                    </div>
                                </td>
                            )}
                            <td>
                                <div className="action-buttons">
                                    {/* Approve — only pending */}
                                    {isPending && (
                                        <button
                                            className="btn-approve"
                                            onClick={() => onApprove(c.id)}
                                            disabled={loading}
                                            title="تأیید و پرداخت"
                                        >
                                            تأیید
                                        </button>
                                    )}

                                    {/* Cancel — pending, approved, paid */}
                                    {!isCancelled && (
                                        <button
                                            className="btn-cancel"
                                            onClick={() => onCancel(c.id)}
                                            disabled={loading}
                                            title={
                                                isPaid
                                                    ? 'لغو پورسانت پرداخت‌شده (اصلاح/بازگشت به کیف پول)'
                                                    : 'لغو پورسانت'
                                            }
                                        >
                                            لغو
                                        </button>
                                    )}

                                    {/* Restore — only cancelled */}
                                    {isCancelled && (
                                        <button
                                            className="btn-restore"
                                            onClick={() => onRestore(c.id)}
                                            disabled={loading}
                                            title="بازگردانی به حالت در انتظار"
                                        >
                                            بازگردانی
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
}